import { render, staticRenderFns } from "./AddFilialeModal.vue?vue&type=template&id=b5195c66&scoped=true"
import script from "./AddFilialeModal.vue?vue&type=script&lang=js"
export * from "./AddFilialeModal.vue?vue&type=script&lang=js"
import style0 from "./AddFilialeModal.vue?vue&type=style&index=0&id=b5195c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5195c66",
  null
  
)

export default component.exports